module.exports = __webpack_public_path__ + "img/ereszkalkulator_kicsi_haz_osszetett_nyeregteto_szines.cd0ea17c.png";